import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjBarcodeCommonModule } from '@grapecity/wijmo.angular2.barcode.common'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, ListItem } from '../../shared'

@Component({
    templateUrl: './qr-codes.component.html',
    styleUrls: ['./qr-codes.component.css'],
    standalone: true,
    imports: [FormsModule, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, WjInputModule, WjBarcodeCommonModule],
})
export class QrCodesComponent extends BaseComponent {
    active = 1
    qrString = 'Equipment Code'
    qrSize = 200
    items: ListItem<string>[] = []
    fuelSources: ListItem<string>[] = []
    fuelDest: ListItem<string>[] = []
    smallTools: ListItem<string>[] = []
    transferableMaterials: ListItem<string>[] = []
    selectedCodes: any[] = []
    custom = ''

    constructor() {
        super()

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get('api/VpEquipment'),
                    this.services.data.get('/api/VpMaterial/GetConsumableMaterials'),
                    this.services.data.get('/api/VpMaterial/GetSmallTools'),
                )
                .subscribe({
                    next: result => {
                        const items = (result[0] as any[]).orderBy(x => x.equipment)
                        for (const item of items) {
                            if (item.udFueler === 'Y') {
                                this.fuelSources.push(new ListItem(item.equipment, item.equipment + ' - ' + item.description))
                            } else if (item.fuelType !== 'N' && item.fuelType !== 'G' && item.equipment[0] !== 'P') {
                                this.fuelDest.push(new ListItem(item.equipment, item.equipment + ' - ' + item.description))
                            }
                        }
                        this.transferableMaterials = result[1].map(x => new ListItem(x.barcode, x.name))
                        this.smallTools = result[2].map(x => new ListItem(x.barcode, x.name))
                    },
                }),
        )
    }

    filterQr() {
        if (this.active === 1) {
            this.selectedCodes = [
                ...this.fuelSources
                    .filter(x => x.$checked)
                    .map(x => {
                        return { value: x.value, display: x.value }
                    }),
                ...this.fuelDest
                    .filter(x => x.$checked)
                    .map(x => {
                        return { value: x.value, display: x.value }
                    }),
            ]
        }
        if (this.active === 2) {
            this.selectedCodes = [
                ...this.transferableMaterials
                    .filter(x => x.$checked)
                    .map(x => {
                        return { value: x.value, display: x.value }
                    }),
                ...this.smallTools
                    .filter(x => x.$checked)
                    .map(x => {
                        return { value: x.value, display: x.value }
                    }),
            ]
        }
        if (this.custom) {
            this.selectedCodes.unshift({ value: this.custom, display: this.custom })
        }
    }

    tabChanged() {
        this.selectedCodes = []
    }
}
